<template>
  <div id="app">
    <router-view @footer="footer"></router-view>
    <!-- loading的显示隐藏 -->
    <van-popup class="apploading" :close-on-click-overlay="false" v-model="loadShow">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </van-popup>
  </div>
</template>

<script>
import Footer from "./components/footer";
import VConsole from "vconsole";

export default {
  name: "App",
  data() {
    return {
      footer_show: true,
      loadShow: false,
    };
  },
  components: {
    "app-footer": Footer,
  },
  methods: {
    //是否显示底部
    footer: function(bool, tab = 0) {
      this.footer_show = false;
    },
    // 显示loading
    Loading: function(bool) {
      this.loadShow = bool;
    },
  },
  mounted() {
    if (process.env.VUE_APP_CONSOLE === "true") {
      var vconsoleFc = new VConsole();
    }
  },
};
</script>

<style lang="scss">
.cuxiaoIcon {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
  width: 0.44rem !important;
  height: 0.27rem !important;
}
.brand-li .van-checkbox__icon .van-icon {
  opacity: 0;
  transform: scale(0.8);
}

.brand-li .van-checkbox__icon--checked .van-icon {
  background-color: #4fae54;
  border-color: #4fae54;
  opacity: 1;
}

* {
  margin: 0;
  padding: 0;
  /* border: 1px solid transparent; */
}
a {
  text-decoration: unset;
  color: #1c1c1c;
}
input[type="submit"] {
  opacity: 0 !important;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1c1c1c;
  // 会导致高度判断不准确
  // overflow-x: hidden;
  min-height: 100vh;
  background: #f6f6f6;
}
.apploading {
  .van-loading {
    width: 2.33rem;
    height: 2.33rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .van-loading__spinner {
    width: 1.2rem;
    height: 1.2rem;
  }
  .van-loading__text {
    font-size: 0.3rem;
  }
}

.des .van-field__label {
  width: 0;
}
.lx-load-box {
  width: 2rem !important;
  height: 2rem !important;
  min-height: 2rem !important;
  margin-left: -1rem !important;
}

.van-cell:not(:last-child):after {
  border-color: transparent !important;
}

.topTitle {
  width: 100%;
  height: 0.8rem;
  background: white;
  color: #1c1c1c;
  font-weight: bold;
  font-size: 0.38rem;
  text-align: center;
  line-height: 0.8rem;
  border-bottom: 0.02rem solid rgb(245, 245, 245);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  /* margin-bottom: 0.8rem; */
}
.backImg {
  position: absolute;
  top: 0.18rem;
  left: 0.2rem;
  width: 0.48rem;
  height: 0.48rem;
}
</style>
